import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import {
  AutoCompleteWithSearch,
  FormLabel,
  ModalError,
  ModalSuccess,
  NumberInput,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors, removeDuplicates } from "utils";

const ModalFormParameterAgent = ({
  open,
  onClose,
  preload,
  getDataTable,
  optionComposer,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    name: "",
    email: "",
    contact_number: "",
    npwp: "",
    agent_fee: 0,
    composer_ids: [],
  });
  const [localFilterSearch, setLocalFilterSearch] = useState("");
  const filteredOptions = optionComposer.filter(client =>
    client?.sure_name.toLowerCase().includes(localFilterSearch.toLowerCase())
  );

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const getDetail = async () => {
    setLoadingPage(true);
    try {
      const res = await axios.get(`${hardBaseUrl}/publisher/agent/${preload}`, {
        headers,
      });
      const data = res?.data?.data;
      setPayload({
        name: data.name,
        email: data.email,
        contact_number: data.contact_number,
        npwp: data.npwp,
        agent_fee: data.percentage_agent_fee || 0,
        composer_ids: data.composers || [],
      });
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;
    const modifiedPayload = {
      ...payload,
      composer_ids:
        payload?.composer_ids?.map(composer => composer?.composer_id) || [],
    };
    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/publisher/agent${preload ? `/${preload}` : ""}`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess(
        `Successfully ${preload ? "update" : "save"} agent`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  useEffect(() => {
    if (preload) {
      getDetail();
    }
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} Agent`}</DialogTitle>
      <DialogContent dividers>
        {loadingPage ? (
          <Grid container direction="column" rowSpacing={2}>
            {Object.keys(payload).map((_, index) => (
              <Grid item key={index}>
                <Box mb="8px">
                  <Skeleton variant="rounded" width="40%" height={25} />
                </Box>
                <Skeleton variant="rounded" width="100%" height={30} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="column" rowSpacing={1}>
            {MockFieldForm?.map(
              ({ title, key, type, suffix, optional }, index) => (
                <Grid item key={index}>
                  <FormLabel label={title} required={!optional} />
                  {type === "autocomplete" ? (
                    <AutoCompleteWithSearch
                      multiple
                      disableCloseOnSelect
                      options={removeDuplicates(filteredOptions, "composer_id")}
                      isOptionEqualToValue={(option, value) =>
                        option?.composer_id === value?.composer_id
                      }
                      optionLabel="sure_name"
                      placeholder="Select Composer"
                      value={payload?.[key]}
                      onChange={e => handleChangePayload(e, "composer_ids")}
                      inputValue={localFilterSearch}
                      onInputChange={value => setLocalFilterSearch(value)}
                      width="100%"
                    />
                  ) : type === "number" ? (
                    <NumberInput
                      placeholder={title}
                      autoComplete={`new-${key}`}
                      value={payload?.[key]}
                      onChange={e =>
                        handleChangePayload(
                          key === "contact_number" ? e : Number(e),
                          key
                        )
                      }
                      endAdornment={suffix}
                      disabled={loadingButton}
                    />
                  ) : (
                    <TextInput
                      placeholder={title}
                      value={payload?.[key]}
                      autoComplete={`new-${key}`}
                      onChange={e => handleChangePayload(e?.target?.value, key)}
                      disabled={loadingButton}
                    />
                  )}
                </Grid>
              )
            )}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingPage}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingPage || loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldForm = [
  {
    title: "Agent Name",
    key: "name",
  },
  {
    title: "Phone Number",
    key: "contact_number",
    type: "number",
  },
  {
    title: "Email",
    key: "email",
  },
  {
    title: "NPWP",
    key: "npwp",
    optional: true,
  },
  {
    title: "Agent Fee",
    key: "agent_fee",
    type: "number",
    suffix: "%",
  },
  {
    title: "Composer",
    key: "composer_ids",
    type: "autocomplete",
  },
];
export default ModalFormParameterAgent;
